'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSpeakerGroup = function MdSpeakerGroup(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 8.4v26.6h16.6v3.4h-16.6c-1.9 0-3.4-1.6-3.4-3.4v-26.6h3.4z m9.1 12.5c0-2.3 2-4.3 4.3-4.3s4.1 2 4.1 4.3-1.9 4.1-4.1 4.1-4.3-1.9-4.3-4.1z m4.3 6.6c3.6 0 6.6-3 6.6-6.6s-3-6.8-6.6-6.8-6.8 3.1-6.8 6.8 3.1 6.6 6.8 6.6z m0-22.5c-1.8 0-3.4 1.5-3.4 3.4s1.6 3.2 3.4 3.2 3.2-1.4 3.2-3.2-1.4-3.4-3.2-3.4z m6.9-3.4c1.7 0 3.1 1.4 3.1 3.1v24c0 1.6-1.4 2.9-3.1 2.9h-14c-1.6 0-2.9-1.3-2.9-2.9v-24c0-1.7 1.3-3.1 2.9-3.1h14z' })
        )
    );
};

exports.default = MdSpeakerGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/speaker-group.js
// module id = 3325
// module chunks = 0